import flatpickr from 'flatpickr';
import mixitup from 'mixitup';

$(() => {
  $('#menu-header-menu li.menu-item-has-children').append('<div class="toggle lg:hidden absolute z-20 top-0 right-0 px-2 py-0-75 bg-grey-lightest"><svg class="svg-inline--fa fa-chevron-down fa-w-14" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg></div>');

  var timing = 200;

  $('#menu-header-menu > li.menu-item-has-children > .toggle').click(function() {
    if ($(this).parent().hasClass('open')) {
      $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
      $(this).parent().parent().find('.sub-menu').slideUp(timing);
    } else {
      $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
      $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
      $(this).parent().toggleClass('open');
      $(this).prev().slideToggle(timing);
    }
  });

  $('#menu-header-menu > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > .toggle').click(function() {
    if ($(this).parent().hasClass('open')) {
      $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
      $(this).parent().parent().find('.sub-menu').slideUp(timing);
    } else {
      $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
      $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
      $(this).parent().toggleClass('open');
      $(this).prev().slideToggle(timing);
    }
  });

  // Desktop nav
  $('#menu-header-menu > li > .sub-menu > li.menu-item-has-children').hover(function() {
    if( $(window).innerWidth() > 991 ) {
      var target = $(this).find('> ul.sub-menu');
      var width = $(target).outerWidth();

      var right_of_screen = $(window).innerWidth();
      var right_of_parent = $(this).offset().left + $(this).outerWidth();
      var right_of_element = right_of_parent + width;

      if (right_of_screen > right_of_element){
        $(target).css('transform', 'translateX(100%)');
        $(target).css('right', '0');
      } else {
        $(target).css('transform', 'translateX(-100%)');
        $(target).css('left', '0');
      }
    }
  });

  $(window).scroll(function() {
      if ($(document).scrollTop() > 90) {
        $('#jewel-navigation').slideUp('fast');
      }
      else {
        $('#jewel-navigation').slideDown('fast');
      }

      if ($(document).scrollTop() > 150) {
        $('.cta-chat-fixed').removeClass('hidden');
      }
  });

  $('.icaal-contact-form select').change(function(){
    $(this).css('color', '#3a3a3a')
  });

  if ($(window).width() > 1024) {
    // Mega Menu

    // Check all mega menu's and add to array
    var megaMenuArr = [];
    $('.mega-menu').each(function() {
      var megaMenuName = $(this).data('mega-menu');
      megaMenuArr.push(megaMenuName);
    });

    // Check if menu item has a mega menu linked & show / hide
    $('#header .menu-item').hover(
      function(){
        for ( var i = 0; i < megaMenuArr.length; i++ ) {
          if ( $(this).hasClass(megaMenuArr[i]) ) {
            $('[data-mega-menu="' + megaMenuArr[i] + '"]').show();
            $('.mega-menu-background').show();
            break;
          }
        }
      },
      function(){
        $('.mega-menu').hide();
        $('.mega-menu-background').hide();
      }
    );
    $('.mega-menu').hover(
      function(){
        $(this).show();
        $('.mega-menu-background').show();
      },
      function(){
        $(this).hide();
        $('.mega-menu-background').hide();
      }
    );
  }

  $('.slick-banner').on('init', function() {
    var hiddenSlides = $('.slick-banner .hidden');
    if(hiddenSlides.length > 1) {
      $('.slick-banner .hidden').each(function(i, el) {
        $(el).removeClass('hidden');
      })
    } else {
      hiddenSlides.removeClass('hidden');
    }
  })

  $('select[name="preferred_time_slot"]').prop('disabled', true);

  var datepicker = $('#datepicker');
  var dt = new Date();
  flatpickr(datepicker, {
    altInput: true,
    dateFormat: 'd-m-Y',
    enableTime: false,
    minDate: dt.setDate(dt.getDate() + 2),
    "disable": [
      function(date) {
        return (date.getDay() === 0);
      }
    ],
    "locale": {
      "firstDayOfWeek": 1,
    },
    onChange: function(selectedDates, dateStr, instance) {
      var selectedDate = new Date(dateStr.split('-').reverse().join('-'));
      if (selectedDate.getDay() === 6) {
        $('#weekdays-time').hide();
        $('#sunday-time').show();
      } else {
        $('#weekdays-time').show();
        $('#sunday-time').hide();
      }
      $('select[name="preferred_time_slot"]').prop('disabled', false);
      $('#preferredTimeSlotMessage').hide();

      if (selectedDate.getDay() === 6) { // If Saturday
        $('select[name="preferred_time_slot"]').val('9 a.m. to 3p.m.'); // Change to your specific option value
      } else {
        $('select[name="preferred_time_slot"]').val('9 a.m. to 5 p.m.'); // Change to your specific option value
      }

    }
  });

  $('.sub-menu-parent').mouseover(function(){
    $(this).find('.sub-menu-popup').addClass('active')
  })
  $('.sub-menu-parent').mouseout(function(){
    $(this).find('.sub-menu-popup').removeClass('active')
  })

  var products = [];
  $('.fake-checkbox-wrap').click(function(){
    var input = $(this).find('input');
    var product = input.val();
    $('.form-quantities').show();

    if (input.is(':checked')) {
      $(this).find('.fake-checkbox svg').show();
      products.push(product);
    } else {
      $(this).find('.fake-checkbox svg').hide();

      var index = products.indexOf(product);
      if (index !== -1) {
        products.splice(index, 1);
      }
    }

    $('[data-product-quantity]').hide();
    products.forEach((item) => {
      $('[data-product-quantity="' + item + '"]').show();
    });


  });

  // Slick
  $('.carousel-content').slick({
    dots: false,
    arrows: true,
    prevArrow: $('.carousel-arrow.left'),
    nextArrow: $('.carousel-arrow.right'),
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 3,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 600,
    draggable: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $('.slick-banner').slick({
    dots: false,
    arrows: false,
    fade: true,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
  });

  $('.news-slider').slick({
    dots: false,
    arrows: true,
    cssEase: 'ease-in-out',
    slidesToShow: 3.25,
    slidestoScroll: 1,
    autoplay: false,
    autoplaySpeed: 4000,
    swipeToSlide: true,
    speed: 600,
    infinite: false,
    prevArrow: $('.news-arrow.left'),
    nextArrow: $('.news-arrow.right'),
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2.25,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2.15,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1.15,
        },
      },
    ],
  });

  $('.related-products-slider').slick({
    dots: false,
    arrows: true,
    cssEase: 'ease-in-out',
    slidesToShow: 3.25,
    slidestoScroll: 1,
    autoplay: false,
    autoplaySpeed: 4000,
    swipeToSlide: true,
    speed: 600,
    infinite: false,
    prevArrow: $('.related-products-arrow.left'),
    nextArrow: $('.related-products-arrow.right'),
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2.25,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1.15,
        },
      },
    ],
  });

  $('.accreditation-carousel').slick({
    dots: false,
    arrows: false,
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 6,
    swipeToSlide: true,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    speed: 600,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });

  $('.gallery-carousel').slick({
    dots: false,
    arrows: false,
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 4,
    swipeToSlide: true,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 600,
    infinite: true,
    mobileFirst: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1.5,
        },
      },
    ],
  });

  $('.gallery-carousel').on('afterChange', function(event, slick, currentSlide) {
    const $currentSlide = $(slick.$slides[currentSlide]);
    $currentSlide.attr('data-loaded', 'true');
  });

  $('.gallery-strip').slick({
    dots: false,
    arrows: false,
    fade: true,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 600,
    infinite: true,
  });

  $('.testimonial-carousel').slick({
    dots: false,
    arrows: false,
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 2,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 600,
    infinite: true,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $('.product-tab.active').slick({
    dots: false,
    arrows: true,
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 3,
    slidestoScroll: 1,
    autoplay: false,
    speed: 600,
    infinite: false,
    prevArrow: $('.product-arrow.left'),
    nextArrow: $('.product-arrow.right'),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.5,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1.5,
        },
      },
    ],
  });

  // Landing Page Gallery Slider
  $('.slick-gallery-landing').slick({
    dots: false,
    infinite: false,
    slidesToShow: 2,
    autoplay: true,
    slidesToScroll: 1,
    draggable: true,
    centerMode: false,
  });

  $('.slick-p').click(function() {
    $(this).parent().prev().slick('slickPrev');
  });
  $('.slick-n').click(function() {
    $(this).parent().prev().slick('slickNext');
  });

  $(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 150,
    }, 500);
  });

  // Newsletter Exit Pop Up
  $(document).mouseleave(function () {
    if (sessionStorage.getItem('newsletter_modal')) {
      null
    } else {
      $('.modal[data-modal="newsletter"]').fadeIn('fast');
    }
    sessionStorage.setItem('newsletter_modal', 'true');
  });
  $('.modal-close').click(function(){
    $(this).parent().parent().hide();
  });

  // Accordion
  $('.accordion-item-header').click(function(){
    $(this).parent().toggleClass('active');
    $(this).next().slideToggle();
  });

  // Finance Tabs
  $('.finance-tab-control').click(function(){
    var target = $(this).data('finance-control');
    $('.finance-tab').removeClass('active');
    $(target).addClass('active');

    $('.finance-tab-control').removeClass('active');
    $(this).addClass('active');
  });

  // Tabbed Products
  $('.product-tab-control').click(function() {
    $('.product-tab-control').removeClass('active');
    $(this).addClass('active');

    $('.product-tab').hide().removeClass('active');
    var target = $(this).data('filter');
    $(target).fadeIn().addClass('active');

    $('.product-tab.slick-initialized').slick('unslick');
    $('.product-tab.active').slick({
      dots: false,
      arrows: true,
      fade: false,
      cssEase: 'ease-in-out',
      slidesToShow: 3,
      slidestoScroll: 1,
      autoplay: false,
      speed: 1000,
      infinite: false,
      prevArrow: $('.product-arrow.left'),
      nextArrow: $('.product-arrow.right'),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  })

  // Tabbed Media
  $('button[name="tab-toggle"]').click(function(){
    $('button[name="tab-toggle"]').addClass('opacity-50');
    $(this).removeClass('opacity-50');
    var target = $(this).data('tab-target');
    $('[data-tab]').hide();
    $('[data-tab="'+ target +'"]').show();
  });

  // Tabbed Media
  $('button[name="endurance-tab-toggle"]').click(function(){
    $('button[name="endurance-tab-toggle"]').removeClass('active');
    $(this).addClass('active');

    var target = $(this).data('target');
    $('[data-endurance-tab]').hide();
    $('[data-endurance-tab="'+ target +'"]').show();
  });

  // Mixitup
  if( $('.mix-container').length ) {
    var mixer = mixitup('.mix-container', {

    });
  }

  // Panel share

  $('.panel-share-close').on('click', function() {
    $('#panel-share').removeClass('active');
  });

  // // Cookie Policy - OLD script befoe icaal plugin
  // $.fn.CookieNotice = function() {
  //   if (!localStorage.getItem('cookie-notice-dismissed')) {
  //     var notice = this;
  //     setTimeout(function() {
  //       notice.addClass('active');
  //     }, 1000);
  //   }
  //   this.addClass('cookie-notice');
  //   return this
  // }
  // $(document).on('click', '.cookie-notice-dismiss', function() {
  //   localStorage.setItem('cookie-notice-dismissed', true);
  //   $(this).parents('.cookie-notice').removeClass('active');
  // })
  // $('#cookie-notice').CookieNotice();

  // Share Button
  $('.page-share').click(function() {
    console.log('test');
    $('#panel-share').toggleClass('active');
  });

  // Sticky cta
  if (localStorage.getItem('stickycta')) {
      $('#sticky-cta').addClass('offscreen')
  } else {
    $('#sticky-cta').removeClass('offscreen')
  }

  $('.sticky-arrow').click(function(){

    if (localStorage.getItem('stickycta')) {
        localStorage.removeItem('stickycta');
        $('#sticky-cta').removeClass('offscreen')
    } else {
      localStorage.setItem('stickycta', 'hidesticky');
      $('#sticky-cta').addClass('offscreen')
    }
  });
  $(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 300) {
        $("#sticky-cta").addClass("active");
    } else {
        $("#sticky-cta").removeClass("active");
    }

  });

  // Mobile Nav
  $('#nav-primary-toggle').click(function() {
    $('.nav-primary').toggleClass('open');
    $('.nav-backdrop').toggleClass('show');
  });

  // Areas We cover page - Show / Hide
  $('.showroomOpeningHours').click(function() {
    $(this).next().slideToggle();
  });

});
